export default __webpack_public_path__ + "static/media/instagram.81095d83.svg";